import Angular from "angular";
import Controller from "./week-date-selection.controller";
import Template from "./week-date-selection.html";
import Settings from "../../providers/settings.provider";

export default Angular.module('week-date-selection', [Settings.name])
    .component('weekDateSelection', {
        template: Template,
        controller: Controller,
        transclude: true,
        bindings: {
            selectedDate: '<',
            selectionMode: '<',
            onDateSelected: '&',
            onNextRange: '&',
            onPrevRange: '&',
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/week-date-selection/week-date-selection.js